import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { Switch } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';

import { ReadingTestLayout } from '../../student-do-test/layouts/ReadingTestLayout';
import { PassageParagraph } from '../components/PassageParagraph';
import { TestContent } from '../components/TestContent';
import { useTestResultStore } from '../model/test-result.hook';

export const ReadingTestResult = observer(() => {
  const store = useTestResultStore();

  const currentQuestion = store.getCurrentQuestionObject();
  return (
    <ReadingTestLayout id="test-result-container">
      <div className="content-wrapper">
        <PassageParagraph id="sidebar-left" />
        <TestContent
          id="body-container"
          explanationAction={
            <div id="btn-locate-explanation" className="header-locate-passage">
              <Typography.Text variant="semi-bold/14">Locate</Typography.Text>
              <Switch
                size="small"
                onClick={currentQuestion?.toggleLocateExplanation}
                checked={currentQuestion?.isLocateExplanationEnabled}
              />
            </div>
          }
        />
      </div>
    </ReadingTestLayout>
  );
});
